export type UserRole = "admin" | "operator" | "manager";

const ROLES: UserRole[] = ["admin", "operator", "manager"];

export const resolveRole = (
  role?: string | null,
  fallback: UserRole = "admin"
): UserRole => {
  if (role && ROLES.includes(role as UserRole)) {
    return role as UserRole;
  }
  return fallback;
};

/** FIX-001: Пользователи — admin и manager */
export const canManageUsers = (role: UserRole) =>
  role === "admin" || role === "manager";

export const canAccessDevices = (role: UserRole) =>
  role === "admin" || role === "operator" || role === "manager";

export const hasFullMenu = (role: UserRole) => role === "admin";

export const isUserRole = (role: UserRole) =>
  role === "manager" || role === "operator";
